<div class="dashboard-container">
  <div class="page-header">
    <h1>Turanmälningar</h1>
  </div>

  <!-- Search and Controls Section -->
  <div class="search-section">
    <div class="search-controls">
      <div class="search-box-container">
        <label>Sök:</label>
        <input
          type="text"
          [(ngModel)]="searchText"
          (input)="onSearchChange()"
          placeholder="Sök namn eller ID..."
          class="search-input">
        </div>

        <div class="time-filter-container">
          <label>Tidsperiod:</label>
          <select [(ngModel)]="selectedTimeRange" (change)="onTimeRangeChange()" [disabled]="isLoading">
            <option value="24">Senaste 24h</option>
            <option value="48">Senaste 48h</option>
            <option value="72">Senaste 72h</option>
          </select>
        </div>
      </div>

      <button
        mat-raised-button
        color="primary"
        class="search-button"
        (click)="loadData()"
        [disabled]="isLoading">
        @if (!isLoading) {
          <mat-icon>refresh</mat-icon>
        }
        @if (isLoading) {
          <mat-icon class="spinner">refresh</mat-icon>
        }
        {{ isLoading ? 'Laddar...' : 'Uppdatera' }}
      </button>
    </div>

    <!-- No results: no data for selected time range -->
    @if (reports.length === 0 && !isLoading) {
      <div class="no-results">
        <mat-icon>info</mat-icon>
        <p>Inga turanmälningar hittades för den valda tidsperioden.</p>
      </div>
    }

    <!-- No results: search filtered everything out -->
    @if (reports.length > 0 && filteredReports.length === 0 && !isLoading) {
      <div class="no-results">
        <mat-icon>filter_alt_off</mat-icon>
        <p>Inga turanmälningar matchar din sökning.</p>
      </div>
    }

    <!-- Results Section -->
    @if (!isLoading && filteredReports.length > 0) {
      <div class="results-section">
        <!-- Results header with count and paginator -->
        <div class="results-header">
          <h2>
            Turanmälningar
            <span class="count">({{ filteredReports.length }})</span>
          </h2>
          <mat-paginator class="paginator dark-results-paginator"
            [length]="filteredReports.length"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            [pageSizeOptions]="pageSizeOptions"
            (page)="onPageChange($event)"
            showFirstLastButtons>
          </mat-paginator>
        </div>
        <!-- Table -->
        <div class="table-container">
          <table class="results-table">
            <thead>
              <tr>
                <th class="sortable-header" (click)="toggleSort()">
                  Tidpunkt
                  <mat-icon class="sort-icon">{{ sortDirection === 'desc' ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
                </th>
                <th>Namn</th>
                <th>Anställd ID</th>
              </tr>
            </thead>
            <tbody>
              @for (report of paginatedReports; track report) {
                <tr>
                  <td>{{ formatTimestamp(report.timeStamp) }}</td>
                  <td>
                    <span class="employee-name" [innerHTML]="report.employeeName | highlight: searchText"></span>
                  </td>
                  <td [innerHTML]="report.employeeId | highlight: searchText"></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }

    <!-- Loading Spinner -->
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner></mat-spinner>
        <p>Hämtar turanmälningar...</p>
      </div>
    }
  </div>
